import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=eb2776ca&scoped=true&"
import script from "./ClienteForm.vue?vue&type=script&lang=js&"
export * from "./ClienteForm.vue?vue&type=script&lang=js&"
import style0 from "./ClienteForm.vue?vue&type=style&index=0&id=eb2776ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2776ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
